angular.module('qkr').directive('inFuture', inFutureFunc);

function inFutureFunc() {
    return {
        require: 'ngModel',
        link(scope, element, attrs, ngModel) {
            ngModel.$validators.inFuture = function(value, value1) {
                return value > Date.now();
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/coupons/directives/inFuture.js